import React from 'react';
import { Field, inputClass } from './BackgroundFields';
import {
  TEXT_KIT_STYLES,
  BUTTON_KIT_STYLES,
  IMAGE_KIT_STYLES,
} from '../utils/designKit';

export function TextKitStyleField({ kitStyle, onChange }) {
  return (
    <Field label="Style visuel (kit Jardins)">
      <select className={inputClass} value={kitStyle || ''} onChange={(e) => onChange(e.target.value)}>
        {TEXT_KIT_STYLES.map((o) => (
          <option key={o.id || 'default'} value={o.id}>
            {o.label}
          </option>
        ))}
      </select>
    </Field>
  );
}

export function TextLinkFields({ props, setProp }) {
  return (
    <>
      <Field label="Lien (optionnel)">
        <select
          className={inputClass}
          value={props.linkType || 'none'}
          onChange={(e) => {
            const v = e.target.value;
            setProp('linkType', v === 'none' ? undefined : v);
          }}
        >
          <option value="none">Aucun</option>
          <option value="section">Ancre section</option>
          <option value="publicPath">Page publique (ex. commande)</option>
          <option value="url">URL externe</option>
        </select>
      </Field>
      {props.linkType === 'section' ? (
        <Field label="Ancre">
          <input
            className={inputClass}
            value={props.sectionAnchor || ''}
            onChange={(e) => setProp('sectionAnchor', e.target.value)}
            placeholder="histoire"
          />
        </Field>
      ) : null}
      {props.linkType === 'publicPath' ? (
        <Field label="Chemin (après /lp/votre-slug)">
          <input
            className={inputClass}
            value={props.publicPath || ''}
            onChange={(e) => setProp('publicPath', e.target.value)}
            placeholder="/commande"
          />
        </Field>
      ) : null}
      {props.linkType === 'url' ? (
        <Field label="URL">
          <input
            className={inputClass}
            value={props.url || ''}
            onChange={(e) => setProp('url', e.target.value)}
            placeholder="https://"
          />
        </Field>
      ) : null}
    </>
  );
}

export function ButtonKitStyleField({ kitStyle, onChange }) {
  return (
    <Field label="Style visuel (kit Jardins)">
      <select className={inputClass} value={kitStyle || ''} onChange={(e) => onChange(e.target.value)}>
        {BUTTON_KIT_STYLES.map((o) => (
          <option key={o.id || 'default'} value={o.id}>
            {o.label}
          </option>
        ))}
      </select>
    </Field>
  );
}

export function ImageKitStyleField({ kitStyle, onChange }) {
  return (
    <Field label="Style visuel (kit Jardins)">
      <select className={inputClass} value={kitStyle || ''} onChange={(e) => onChange(e.target.value)}>
        {IMAGE_KIT_STYLES.map((o) => (
          <option key={o.id || 'default'} value={o.id}>
            {o.label}
          </option>
        ))}
      </select>
    </Field>
  );
}

export function SectionDesignKitField({ designKit, kitSectionTone, onChangeKit, onChangeTone }) {
  return (
    <>
      <Field label="Kit de design">
        <select className={inputClass} value={designKit || ''} onChange={(e) => onChangeKit(e.target.value || undefined)}>
          <option value="">Aucun</option>
          <option value="jardins">La Table des Jardins</option>
        </select>
      </Field>
      {designKit === 'jardins' ? (
        <Field label="Ambiance section">
          <select
            className={inputClass}
            value={kitSectionTone || ''}
            onChange={(e) => onChangeTone(e.target.value || undefined)}
          >
            <option value="">Standard (papier)</option>
            <option value="header">En-tête (menu sticky)</option>
            <option value="hero-dark">Hero sombre</option>
            <option value="forest">Fond vert forêt</option>
            <option value="quote">Fond citation</option>
            <option value="footer">Pied de page sombre</option>
          </select>
        </Field>
      ) : null}
    </>
  );
}
